// Stav propojení Slacku pro status 🌴 během dovolené (21.9.2026).
// Jeden dotaz na /api/slack-status za načtení stránky, sdílený všemi místy
// (pruh pod lištou, menu u jména, sheet Více). Změna se rozešle událostí.
import { useEffect, useState } from "react";
import { apiFetch } from "./api.js";

const UDALOST = "fw40-slack-status";
let stav = null;        // { propojeno, platne } nebo null (ještě nevíme)
let bezi = null;

function rozesli() {
  try { window.dispatchEvent(new CustomEvent(UDALOST)); } catch { /* test */ }
}

export async function nactiSlackStatus(znovu = false) {
  if (stav && !znovu) return stav;
  if (bezi && !znovu) return bezi;
  bezi = apiFetch("/api/slack-status")
    .then((r) => (r.ok ? r.json() : null))
    .then((j) => {
      stav = j ? { propojeno: !!j.propojeno, platne: !!j.platne, pripraveno: j.pripraveno !== false } : { propojeno: false, platne: false, chyba: true };
      rozesli();
      return stav;
    })
    .catch(() => { stav = { propojeno: false, platne: false, chyba: true }; rozesli(); return stav; })
    .finally(() => { bezi = null; });
  return bezi;
}

export function useSlackStatus() {
  const [s, setS] = useState(stav);
  useEffect(() => {
    const h = () => setS(stav);
    window.addEventListener(UDALOST, h);
    nactiSlackStatus();
    return () => window.removeEventListener(UDALOST, h);
  }, []);
  return s;
}

/** Přesměruje na Slack „Povolit“. Po návratu přijde ?slack=ok. */
export async function propojitSlack() {
  const zpet = window.location.pathname + window.location.search.replace(/[?&]slack=[^&]*/g, "");
  const r = await apiFetch("/api/slack-status", { method: "POST", body: JSON.stringify({ action: "start", zpet }) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok || !j.url) throw new Error(j.error || "Propojení se nepodařilo spustit");
  window.location.href = j.url;
}

export async function odpojitSlack() {
  const r = await apiFetch("/api/slack-status", { method: "POST", body: JSON.stringify({ action: "odpojit" }) });
  if (!r.ok) throw new Error("Odpojení se nepovedlo");
  stav = { ...(stav || {}), propojeno: false, platne: false };
  rozesli();
}

/** Owner jednou uloží Client Secret Slack aplikace (v env není místo). */
export async function ulozSlackSecret(hodnota) {
  const r = await apiFetch("/api/slack-status", { method: "POST", body: JSON.stringify({ action: "secret", hodnota }) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Uložení se nepovedlo");
  await nactiSlackStatus(true);
}
